import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {Ajax} from "../../Service/ajax";

export default function SubscriptionForm({ title, subscription, cmp, onCloseModal }) {
    const session = sessionStorage.getItem("session");
    const navigate = useNavigate();
    const url = window.location.pathname + window.location.search;
    const [inputValues, setInputValues] = useState(Array(subscription.infos.length).fill(''));
    const [inputErrors, setInputErrors] = useState(Array(subscription.infos.length).fill(false));
    const handleInputChange = (index, value) => {
        const newInputValues = [...inputValues];
        newInputValues[index] = value;
        setInputValues(newInputValues);
        setInputErrors(inputErrors.map((error, i) => (i === index ? false : error)));
    };


    const handleNavigation = () => {
        const isAllFieldsFilled = inputValues.every(value => value.trim() !== '');
        if (isAllFieldsFilled) {
            const infos = subscription.infos.map((item, index) => ({
                id: item.id,
                value: inputValues[index]
            }));

            const fetchData = async ()=>{
                try {
                    const {data} = await Ajax.postRequest("/api/v1/sub/subscription/"+subscription.id+"/subscribe", infos);
                    if(data.error){
                        const url = window.location.pathname + window.location.search;
                        navigate("/payment-check", { state: { errors: url } });
                    }else{
                        const {object} = data;
                        navigate("/payment-check", { state: { success: JSON.stringify(object) } });
                    }
                }catch (error){
                    const url = window.location.pathname + window.location.search;
                    navigate("/payment-check", { state: { errors: url } });
                }
            }

            if (session) {
                if(subscription.price > 0 ){
                    subscription["cmp"] = cmp;
                    subscription["infos"] = infos;
                    navigate("/payment", { state: { someData: JSON.stringify(subscription) } });
                }else{
                    fetchData();
                }
            } else {
                window.location.replace(window.location.origin + "/login?redirectUrl=" + url);
            }
        } else {
            const newInputErrors = inputValues.map(value => value.trim() === '');
            setInputErrors(newInputErrors);
        }
    };

    const handleCloseModal = () => {
        if (onCloseModal) {
            onCloseModal();
        }
    };

    return (
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title" id="modalFullTitle">{title}</h5>
                <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={handleCloseModal}
                ></button>
            </div>
            <div className="modal-body">
                <div className="col-md-12 d-flex justify-content-center ">
                    <div className="col-md-6">
                        {subscription.infos.map((item, index) => (
                            <div key={index} className="form-floating mb-2">
                                <input
                                    type={item.dataType}
                                    className={`form-control ${inputErrors[index] ? 'is-invalid' : ''}`}
                                    id={index}
                                    placeholder={"Saisissez le " + item.tag}
                                    value={inputValues[index]}
                                    onChange={(e) => handleInputChange(index, e.target.value)}
                                />
                                <label htmlFor={index}>{item.tag}</label>
                                {inputErrors[index] && <div className="invalid-feedback">Ce champ est requis.</div>}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-outline-netikash" data-bs-dismiss="modal" onClick={handleCloseModal}>
                    Annuler
                </button>
                <button type="button" className="btn btn-netikash" data-bs-dismiss="modal" onClick={handleNavigation}>Procéder au paiement</button>
            </div>
        </div>
    );
}